// extracted by mini-css-extract-plugin
export default {"help":"help---XCs7Q"};